export let undispatchDepth = 0

export function suspendUndispatch<T>(fn: () => T): T {
  if (undispatchDepth === 0) {
    return fn()
  }
  const prevUndispatchDepth = undispatchDepth
  undispatchDepth = 0
  try {
    return fn()
  } finally {
    undispatchDepth = prevUndispatchDepth
  }
}

export function undispatch<T>(fn: () => T): T {
  if (undispatchDepth > 0) {
    return fn()
  }
  undispatchDepth++
  try {
    return fn()
  } finally {
    undispatchDepth--
  }
}
